import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GeneticMaterialTypeCreateDto, GeneticMaterialTypeDto, GeneticMaterialTypeExcelDownloadDto, GeneticMaterialTypeUpdateDto, GetGeneticMaterialTypesInputDto } from '../dtos/genetic-material-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class GeneticMaterialTypeService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: GeneticMaterialTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialTypeDto>({
      method: 'POST',
      url: '/api/general/geneticMaterialTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/geneticMaterialTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/geneticMaterialTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialTypeDto>({
      method: 'GET',
      url: `/api/general/geneticMaterialTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/geneticMaterialTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetGeneticMaterialTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<GeneticMaterialTypeDto>>({
      method: 'GET',
      url: '/api/general/geneticMaterialTypes',
      params: { name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: GeneticMaterialTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/geneticMaterialTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialTypeDto[]>({
      method: 'GET',
      url: '/api/general/geneticMaterialTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: GeneticMaterialTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialTypeDto>({
      method: 'PUT',
      url: `/api/general/geneticMaterialTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}